import { liteClient as o } from "./help-center-articles-search44.js";
const n = "A31FV0KTHH", c = "f1b5e922de651c11f03d8878b7c52600", a = o(n, c), i = (e, t) => `vistaprint_${t}_${e?.toLowerCase()}_helpcenter`.toLowerCase();
export {
  n as ALGOLIA_APP_ID,
  c as ALGOLIA_CLIENT,
  a as algoliaSearchClient,
  i as getIndexName
};
//# sourceMappingURL=help-center-articles-search21.js.map
